import styles from './ClearStampsRow.module.scss';
import SvgPrizeCocoa from 'images/icon/prize_cocoa.svg';

type Props = {
  clearStampIds: (string | null)[];
  displayNumberOffset: number;
  showPrizeIconForLast: boolean;
};

function getClearStampFileName(id: string) {
  return `${String(id).padStart(3, '0')}_clear-stamp.png`;
}

export const ClearStampsRow = ({
  clearStampIds,
  displayNumberOffset,
  showPrizeIconForLast,
}: Props) => {
  const numFillingItems = 5 - clearStampIds.length;
  return (
    <div className={styles.base}>
      {clearStampIds.map((areaId, index) => {
        const stampUrl = areaId
          ? require(`components/pages/Area/images/${getClearStampFileName(areaId)}`)
          : undefined;
        const isLast = showPrizeIconForLast ? index === clearStampIds.length - 1 : false;
        const displayNumber = displayNumberOffset + index;
        return (
          <div key={index} className={styles.card}>
            {areaId ? (
              <img src={stampUrl} alt={`clear stamp of ${areaId}`} />
            ) : (
              <div className={styles.cardContentEmpty}>
                {isLast && <img src={SvgPrizeCocoa} />}
                {!isLast && <div>{displayNumber}</div>}
              </div>
            )}
          </div>
        );
      })}
      {[...Array(numFillingItems)].map(index => (
        <div className={styles.card} key={`dummy-${index}`} />
      ))}
    </div>
  );
};
